import ReactLoading from "react-loading";
import { useState } from "react";

export const CardGerarPagamento = ({ usuario, gerar, isLoadingPayment, tipo }) => {
    const [nomeProcedimento, setNomeProcedimento] = useState("");
    const [valor, setValor] = useState("");

    const adjustValue = (amount) => {
        setValor((prev) => Math.max(0, (parseFloat(prev) || 0) + amount).toString());
    };

    return (
        <div className="w-full max-w-2xl bg-purple-800 rounded-2xl shadow-xl overflow-hidden">
            {/* Header com informações do usuário */}
            <div className="p-6 border-b border-purple-600">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="space-y-3">
                        <div className="flex flex-col">
                            <span className="text-purple-200 text-xs uppercase tracking-wider font-medium">Nome</span>
                            <span className="text-white font-semibold text-lg">
                                {`${usuario.NO_primeiro_nome ?? ""} ${usuario.NO_ultimo_nome ?? ""}`.trim()}
                            </span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-purple-200 text-xs uppercase tracking-wider font-medium">Email</span>
                            <span className="text-white font-medium truncate">{usuario.DS_email}</span>
                        </div>
                    </div>
                    <div className="space-y-3">
                        <div className="flex flex-col">
                            <span className="text-purple-200 text-xs uppercase tracking-wider font-medium">CPF</span>
                            <span className="text-white font-medium">{usuario.NU_cpf}</span>
                        </div>
                        <div className="flex flex-col">
                            <span className="text-purple-200 text-xs uppercase tracking-wider font-medium">Telefone</span>
                            <span className="text-white font-medium">{usuario.NU_telefone}</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Seção de procedimento */}
            {tipo === "procedimento" && (
                <div className="p-6 space-y-4">
                    {/* Input do nome do procedimento */}
                    <div className="flex flex-col gap-2 max-w-lg mx-auto">
                        <label className="text-purple-200 text-xs uppercase tracking-wider font-medium">
                            Nome do Procedimento
                        </label>
                        <input
                            type="text"
                            className="w-full px-4 py-3 bg-white border-2 border-purple-400 rounded-lg text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all"
                            placeholder="Digite o nome do procedimento"
                            value={nomeProcedimento}
                            onChange={(event) => setNomeProcedimento(event.target.value)}
                        />
                    </div>

                    {/* Controles de valor */}
                    <div className="flex flex-col gap-2 items-center">
                        <label className="text-purple-200 text-xs uppercase tracking-wider font-medium text-center">
                            Valor (Créditos)
                        </label>
                        <div className="flex items-center justify-center gap-2 flex-wrap">
                            <button
                                type="button"
                                onClick={() => adjustValue(-0.5)}
                                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white font-bold rounded-lg transition-all shadow-md hover:shadow-lg active:scale-95 cursor-pointer"
                            >
                                -0.5
                            </button>
                            <button
                                type="button"
                                onClick={() => adjustValue(-0.25)}
                                className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-bold rounded-lg transition-all shadow-md hover:shadow-lg active:scale-95 cursor-pointer"
                            >
                                -0.25
                            </button>

                            <input
                                type="number"
                                step="any"
                                min="0"
                                className="w-24 px-3 py-2 bg-white text-purple-900 font-bold text-center rounded-lg border-2 border-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all"
                                placeholder="0"
                                value={valor}
                                onChange={(event) => setValor(event.target.value)}
                            />

                            <button
                                type="button"
                                onClick={() => adjustValue(0.25)}
                                className="px-4 py-2 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg transition-all shadow-md hover:shadow-lg active:scale-95 cursor-pointer"
                            >
                                +0.25
                            </button>
                            <button
                                type="button"
                                onClick={() => adjustValue(0.5)}
                                className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg transition-all shadow-md hover:shadow-lg active:scale-95 cursor-pointer"
                            >
                                +0.5
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Botão Gerar Token */}
            <div className={`p-6 ${tipo === "procedimento" ? "pt-0" : ""}`}>
                <button
                    disabled={isLoadingPayment}
                    onClick={() =>
                        tipo === "procedimento"
                            ? gerar(usuario.DS_email, nomeProcedimento, parseFloat(valor) || 0)
                            : gerar(usuario.DS_email)
                    }
                    className={`w-full py-4 rounded-xl font-bold text-lg transition-all shadow-lg flex items-center justify-center gap-2 cursor-pointer ${isLoadingPayment
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-[#067187] hover:bg-[#49B69B] text-white hover:shadow-xl active:scale-[0.98]"
                        }`}
                >
                    {isLoadingPayment ? (
                        <ReactLoading
                            type="spin"
                            color="#ffffff"
                            height={24}
                            width={24}
                        />
                    ) : (
                        <>
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
                            </svg>
                            Gerar Token
                        </>
                    )}
                </button>
            </div>
        </div>
    );
};